<app-header></app-header>

<!-- Success Notification Component -->
<app-success-notification-card
  [show]="showSuccessMessage"
  [title]="successTitle" 
  [subtitle]="successSubtitle"
  (close)="onSuccessClose()"
></app-success-notification-card>

<!-- Contenedor principal -->
<section class="w-full min-h-[calc(100vh-64px)] bg-white">
  <div class="mx-auto w-full md:max-w-[960px]">
    <!-- Header con fondo gris -->
    <div class="bg-neutral-gray-100 px-6 pt-6 pb-8">
      <!-- Botón Volver -->
      <button (click)="goBack()" class="flex items-center gap-1 mb-6">
       <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.667 9.88148C16.667 10.4074 16.2407 10.8345 15.7148 10.8346L6.58594 10.8346L9.72168 13.9704C10.0934 14.3422 10.0933 14.9451 9.72168 15.317C9.34975 15.689 8.74595 15.689 8.37402 15.317L3.6123 10.5553C3.5681 10.5111 3.529 10.462 3.49414 10.4098C3.48501 10.3961 3.4771 10.3818 3.46875 10.3678C3.46135 10.3554 3.45313 10.3435 3.44629 10.3307C3.43995 10.3189 3.43451 10.3066 3.42871 10.2946C3.42049 10.2775 3.41249 10.2604 3.40527 10.2428C3.39791 10.2248 3.39196 10.2064 3.38574 10.1881C3.38276 10.1794 3.37969 10.1706 3.37695 10.1618C3.37319 10.1495 3.37044 10.137 3.36719 10.1246C3.35595 10.082 3.34705 10.0386 3.3418 9.99379C3.33299 9.91908 3.33293 9.84388 3.3418 9.76918C3.34732 9.72242 3.35612 9.6769 3.36816 9.63246C3.37072 9.623 3.37312 9.61353 3.37598 9.60414C3.3798 9.59159 3.38435 9.57936 3.38867 9.56703C3.39462 9.55004 3.40028 9.53295 3.40723 9.51625C3.41262 9.5033 3.41886 9.49081 3.4248 9.47816C3.43196 9.4629 3.43828 9.44721 3.44629 9.43227C3.45314 9.4195 3.46135 9.40756 3.46875 9.39516C3.47711 9.38115 3.485 9.36682 3.49414 9.35316C3.52889 9.30123 3.5683 9.25267 3.6123 9.20863L8.37402 4.44691C8.74595 4.07499 9.34975 4.07499 9.72168 4.44691C10.0933 4.81885 10.0934 5.42177 9.72168 5.79359L6.58594 8.92934L15.7148 8.92934C16.2406 8.92946 16.6668 9.35575 16.667 9.88148Z" fill="#20202A"/>
</svg>
        <span class="text-[12px] font-poppins font-bold text-neutral-gray-900"
          >Volver</span
        >
      </button>

      <!-- Título -->
      <div class="flex flex-col gap-2 items-start justify-center">
        <h1
          class="text-[20px] font-poppins font-semibold text-neutral-gray-900 leading-tight"
        >
          Mi Perfil
        </h1>
        <p
          class="text-[14px] font-poppins font-normal text-neutral-gray-700 leading-tight"
        >
          Datos de la cuenta
        </p>
      </div>
    </div>

    <!-- Formulario (Solo lectura) -->
    <div class="flex flex-col gap-4 px-6 py-6">
      <!-- Nombres -->
      <div class="flex flex-col gap-2">
        <label class="text-[16px] font-poppins font-medium text-neutral-gray-900 px-3"
          >Nombres</label
        >
        <div
          class="flex items-center gap-3 h-14 px-4 bg-neutral-gray-100 border border-neutral-gray-200 rounded-lg"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            class="flex-shrink-0"
          >
            <path
              d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
              stroke="#7E808F"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span
            class="flex-1 text-[16px] font-poppins font-medium text-neutral-gray-600"
            >{{ userData.firstname || "Nombres" }}</span
          >
        </div>
      </div>

      <!-- Apellidos -->
      <div class="flex flex-col gap-2">
        <label class="text-[16px] font-poppins font-medium text-neutral-gray-900 px-3"
          >Apellidos</label
        >
        <div
          class="flex items-center gap-3 h-14 px-4 bg-neutral-gray-100 border border-neutral-gray-200 rounded-lg"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            class="flex-shrink-0"
          >
            <path
              d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
              stroke="#7E808F"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span
            class="flex-1 text-[16px] font-poppins font-medium text-neutral-gray-600"
            >{{ userData.lastname || "Apellidos" }}</span
          >
        </div>
      </div>

      <!-- Celular -->
      <div class="flex flex-col gap-2">
        <label class="text-[16px] font-poppins font-medium text-neutral-gray-900 px-3"
          >Celular</label
        >
        <div
          class="flex items-center gap-3 h-14 px-4 bg-neutral-gray-100 border border-neutral-gray-200 rounded-lg"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            class="flex-shrink-0"
          >
            <rect
              x="5"
              y="2"
              width="14"
              height="20"
              rx="2"
              ry="2"
              stroke="#AEAEB8"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <line
              x1="12"
              y1="18"
              x2="12.01"
              y2="18"
              stroke="#AEAEB8"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span
            class="flex-1 text-[16px] font-poppins font-medium text-neutral-gray-600"
            >{{ userData.phone || "999 999 999" }}</span
          >
        </div>
      </div>

      <!-- DNI -->
      <div class="flex flex-col gap-2">
        <label class="text-[16px] font-poppins font-medium text-neutral-gray-900 px-3"
          >DNI</label
        >
        <div
          class="flex items-center gap-3 h-14 px-4 bg-neutral-gray-100 border border-neutral-gray-200 rounded-lg"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 10.666C13 10.1137 13.4477 9.66602 14 9.66602H18C18.5523 9.66602 19 10.1137 19 10.666C19 11.2183 18.5523 11.666 18 11.666H14C13.4477 11.666 13 11.2183 13 10.666Z"
              fill="#AEAEB8"
            />
            <path
              d="M14 12.666C13.4477 12.666 13 13.1137 13 13.666C13 14.2183 13.4477 14.666 14 14.666H18C18.5523 14.666 19 14.2183 19 13.666C19 13.1137 18.5523 12.666 18 12.666H14Z"
              fill="#AEAEB8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.875 7.99927C7.49312 7.99927 6.38971 9.13913 6.38971 10.5243C6.38971 11.1804 6.63733 11.7816 7.04487 12.2325C6.5469 12.3236 6.0852 12.5677 5.72444 12.9357C5.25949 13.4099 5 14.0511 5 14.7176V15.5276C5 16.018 5.39234 16.4326 5.89706 16.4326C6.40178 16.4326 6.79412 16.018 6.79412 15.5276V14.7176C6.79412 14.5248 6.86929 14.3419 7.00004 14.2085C7.13046 14.0755 7.30521 14.0026 7.48529 14.0026H10.2647C10.4448 14.0026 10.6195 14.0755 10.75 14.2085C10.8807 14.3419 10.9559 14.5248 10.9559 14.7176V15.5276C10.9559 16.018 11.3482 16.4326 11.8529 16.4326C12.3577 16.4326 12.75 16.018 12.75 15.5276V14.7176C12.75 14.0511 12.4905 13.4099 12.0256 12.9357C11.6648 12.5677 11.2031 12.3236 10.7051 12.2326C11.1127 11.7816 11.3603 11.1804 11.3603 10.5243C11.3603 9.13913 10.2569 7.99927 8.875 7.99927ZM8.18382 10.5243C8.18382 10.12 8.50256 9.80927 8.875 9.80927C9.24744 9.80927 9.56618 10.12 9.56618 10.5243C9.56618 10.9285 9.24744 11.2393 8.875 11.2393C8.50256 11.2393 8.18382 10.9285 8.18382 10.5243Z"
              fill="#AEAEB8"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2 6.84409C2 5.63328 2.98753 4.66602 4.188 4.66602H19.812C21.0125 4.66602 22 5.63328 22 6.84409V17.4879C22 18.6988 21.0125 19.666 19.812 19.666H4.188C2.98753 19.666 2 18.6988 2 17.4879V6.84409ZM4.188 6.66602C4.07624 6.66602 4 6.75364 4 6.84409V17.4879C4 17.5784 4.07624 17.666 4.188 17.666H19.812C19.9238 17.666 20 17.5784 20 17.4879V6.84409C20 6.75364 19.9238 6.66602 19.812 6.66602H4.188Z"
              fill="#AEAEB8"
            />
          </svg>
          <span
            class="flex-1 text-[16px] font-poppins font-medium text-neutral-gray-600"
            >{{ userData.dni || "DNI" }}</span
          >
        </div>
      </div>
    </div>

    <!-- Botón Editar -->
    <div class="px-6 pb-8">
      <button
        (click)="openEditModal()"
        class="w-full h-14 bg-cantera-red-primary hover:bg-[#B01E1A] transition-colors rounded-lg flex items-center justify-center gap-2"
      >
        <span class="text-[16px] font-poppins font-bold text-white"
          >Editar datos</span
        >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3 18H7C7.3 18 7.5 17.9 7.7 17.7L18.7 6.7C19.1 6.3 19.1 5.7 18.7 5.3L14.7 1.3C14.3 0.9 13.7 0.9 13.3 1.3L2.3 12.3C2.1 12.5 2 12.7 2 13V17C2 17.6 2.4 18 3 18ZM4 13.4L14 3.4L16.6 6L6.6 16H4V13.4ZM22 22C22 22.6 21.6 23 21 23H3C2.4 23 2 22.6 2 22C2 21.4 2.4 21 3 21H21C21.6 21 22 21.4 22 22Z"
            fill="white"
          />
        </svg>
      </button>
    </div>
  </div>
</section>

<!-- Modal de Edición -->
<div
  *ngIf="showEditModal"
  class="px-4 fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
  (click)="closeEditModal()"
>
  <div
    class="bg-white px-4 py-6 rounded-2xl w-full max-w-[600px] p-6 shadow-xl animate-slide-up"
    (click)="$event.stopPropagation()"
  >
    <!-- Título del Modal -->
    <div class="flex flex-col items-center justify-center mb-6">
      <h2
        class="text-[20px] font-poppins font-semibold text-neutral-gray-900 text-center"
      >
        Editar datos
      </h2>
    </div>

    <!-- Campos Editables -->
    <div class="flex flex-col gap-4 mb-6">
      <!-- Nombres -->
      <div
        class="flex items-center gap-3 h-14 px-4 bg-white border-2 border-neutral-gray-900 rounded-lg"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          class="flex-shrink-0"
        >
          <path
            d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
            stroke="#20202A"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <div class="flex flex-col flex-1">
          <label class="text-[12px] font-poppins text-neutral-gray-600">Nombres</label>
          <input
            type="text"
            [(ngModel)]="editData.firstname"
            class="text-[16px] font-poppins font-medium text-neutral-gray-900 outline-none bg-transparent"
            placeholder="Nombres"
          />
        </div>
      </div>

      <!-- Apellidos -->
      <div
        class="flex items-center gap-3 h-14 px-4 bg-white border-2 border-neutral-gray-900 rounded-lg"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          class="flex-shrink-0"
        >
          <path
            d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
            stroke="#20202A"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <div class="flex flex-col flex-1">
          <label class="text-[12px] font-poppins text-neutral-gray-600"
            >Apellidos</label
          >
          <input
            type="text"
            [(ngModel)]="editData.lastname"
            class="text-[16px] font-poppins font-medium text-neutral-gray-900 outline-none bg-transparent"
            placeholder="Apellidos"
          />
        </div>
      </div>

      <!-- Celular -->
      <div
        class="flex items-center gap-3 h-14 px-4 bg-white border-2 border-neutral-gray-900 rounded-lg"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          class="flex-shrink-0"
        >
          <rect
            x="5"
            y="2"
            width="14"
            height="20"
            rx="2"
            ry="2"
            stroke="#20202A"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <line
            x1="12"
            y1="18"
            x2="12.01"
            y2="18"
            stroke="#20202A"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <div class="flex flex-col flex-1">
          <label class="text-[12px] font-poppins text-neutral-gray-600">Celular</label>
          <input
            type="text"
            [(ngModel)]="editData.phone"
            (input)="onPhoneInputChange($event)"
            maxlength="9"
            class="text-[16px] font-poppins font-medium text-neutral-gray-900 outline-none bg-transparent"
            placeholder="999 999 999"
          />
        </div>
      </div>
    </div>

    <!-- Botones -->
    <div class="flex flex-col gap-2">
      <button
        (click)="saveChanges()"
        class="w-full h-14 bg-cantera-red-primary hover:bg-[#B01E1A] transition-colors rounded-lg flex items-center justify-center"
      >
        <span class="text-[16px] font-poppins font-bold text-white"
          >Guardar cambios</span
        >
      </button>
      <button
        (click)="closeEditModal()"
        class="w-full h-14 bg-white border-2 border-neutral-gray-900 hover:bg-gray-50 transition-colors rounded-lg flex items-center justify-center"
      >
        <span class="text-[16px] font-poppins font-bold text-neutral-gray-900"
          >Cancelar</span
        >
      </button>
    </div>
  </div>
</div>
